<template>
  <resource-box :name="resourceName">
    <div slot="back" class="backBtn parallelogram" @click="backBtn">
      <span class="content">上一级</span>
    </div>
    <div style="width: 100%; height: 100%" slot="content">
      <div class="chart-container" ref="chartContainer">
        <!-- 空状态提示 -->
        <div v-if="isEmpty" class="empty-chart">
          <img :src="require('@/assets/recycling/index/empty.svg')" alt="暂无数据" class="empty-image">
          <p class="empty-text">暂无数据</p>
        </div>
      </div>
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import * as echarts from 'echarts';

export default {
  name: 'dataGglance',
  components: {
    resourceBox,
  },
  props: {
    materials: {
      type: Array,
      default: () => [],
    },
    areaTopData: {
      type: Array,
      default: () => [],
      required: true
    },
  },
  data() {
    return {
      resourceName: this.$store.state.echartsMap.lowerLevelData.typeName + '（市/州）排名',
      chart: null,
      isEmpty: false,
      chartOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}个'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%', // 为X轴标签留更多空间
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 12,
            interval: 0, // 强制显示所有标签
            rotate: 30, // 标签旋转30度防止重叠
            margin: 15 // 标签与轴线距离
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '数量(个)',
          nameTextStyle: {
            color: 'rgba(255, 255, 255, 0.7)',
            padding: [0, 0, 0, 0], // 调整左侧padding，确保名称不会与标签重叠
            align: 'left' // 名称右对齐
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            margin: 8 // 增加标签与轴线的间距
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            barWidth: '40%',
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 191, 255, 0.8)' },
                { offset: 1, color: 'rgba(47, 241, 255, 0.8)' }
              ]),
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(0, 191, 255, 1)' },
                  { offset: 1, color: 'rgba(47, 241, 255, 1)' }
                ]),
                shadowColor: 'rgba(0, 191, 255, 0.5)',
                shadowBlur: 10,
                shadowOffsetY: 3
              }
            },
            label: {
              show: true,
              position: 'top',
              color: 'rgba(47, 241, 255, 1)',
              formatter: '{c}'
            }
          }
        ],
        animationDuration: 1000
      }
    };
  },
  computed: {
    hasData() {
      return this.areaTopData && this.areaTopData.length > 0;
    }
  },
  watch: {
    areaTopData: {
      handler(newVal) {
        newVal = newVal.filter(item=>{
          return item.amount !== 0
        })
        if (this.hasData && newVal.length) {
          this.isEmpty = false;
          this.updateChartData(newVal);
        } else {
          this.showEmptyState();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chartContainer);
      }
      this.chart.setOption(this.chartOptions);
    },
    updateChartData(data) {
      // 按数量降序排序
      const sortedData = [...data].sort((a, b) => b.amount - a.amount);

      this.chartOptions.xAxis.data = sortedData.map(item => item.name);
      this.chartOptions.series[0].data = sortedData.map(item => item.amount);

      if (this.chart) {
        this.chart.setOption(this.chartOptions, true);
      }
    },
    showEmptyState() {
      this.isEmpty = true;
      if (this.chart) {
        this.chart.clear();
        // 也可以设置空状态选项
        this.chart.setOption({
          graphic: {
            elements: [
              // 自定义图片
              {
                type: 'image',
                left: 'center',
                top: 'center',
                style: {
                  image: require('@/assets/recycling/index/empty.svg'), // 图片路径
                  width: 150,
                  height: 150,
                },
              },
              // 文字提示
            ]
          }
        });
      }
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    backBtn() {
      this.$store.state.echartsMap.isLower = false;
      this.$store.state.echartsMap.lowerLevelData = {};
      this.$store.commit('echartsMap/changeGlanceType', undefined);
      this.$emit('goTopLevel', true);
    }
  }
};
</script>

<style lang="less" scoped>
.parallelogram {
  width: 95px;
  height: 32px;
  cursor: pointer;
  border-radius: 1px;
  background: linear-gradient(
      -15deg,
      rgba(0, 191, 255, 0.5) 0%,
      rgba(0, 191, 255, 0) 100%
  );
  border: 2px solid rgba(0, 0, 0, 0);
  box-shadow: 0px 4px 9px rgba(2, 6, 10, 0.35);
  transform: skew(20deg);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
  font-family: Arial, sans-serif;

  &:hover {
    background: linear-gradient(
        180deg,
        rgba(0, 132, 255, 0.2) 0%,
        rgba(0, 191, 255, 1) 100%
    );
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
  }

  .content {
    transform: skew(-20deg);
  }
}

.backBtn {
  width: 70px;
  height: 26px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}

.chart-container {
  width: 100%;
  height: 100%;
  padding: 10px;
  position: relative;

  .empty-chart {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .empty-image {
      width: 100px;
      height: 100px;
      opacity: 0.6;
      margin-bottom: 10px;
    }

    .empty-text {
      color: rgba(255, 255, 255, 0.7);
      font-size: 16px;
      margin-top: 10px;
    }
  }
}
</style>
